import CryptoJS from "crypto-js";

// Replace with your fixed key
const keyHex = CryptoJS.enc.Hex.parse("9f2e87a3484d2a7d2a63c1c2a4cb38474bfa2f0d8388f7b69d3c8a56d1a1206b");

// Encrypt Function with Fixed Key and Random IV
const encryptData = (word) => {
    const iv = CryptoJS.lib.WordArray.random(16); // Generate random IV

    // Encrypt with fixed key and generated IV
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(word), keyHex, { iv: iv });

    return {
        iv: iv.toString(CryptoJS.enc.Hex),   // IV in Hex format
        ciphertext: encrypted.ciphertext.toString(CryptoJS.enc.Hex), // Raw ciphertext in Hex format
    };
};


// Decrypt Function using IV and Ciphertext
const decryptData = (encryptedData) => {
    const { iv, ciphertext } = encryptedData;

    // Reconstruct CipherParams from ciphertext
    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Hex.parse(ciphertext),
    });

    // Decrypt using the fixed key and IV
    const decrypted = CryptoJS.AES.decrypt(cipherParams, keyHex, {
        iv: CryptoJS.enc.Hex.parse(iv), // Parse IV from Hex
    });

    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)); // Return parsed plaintext
};

export { encryptData, decryptData };
